import {AssignedSocialHelpResponsePayload} from '../../../shared/models/api';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';

export interface PrivilegeState {
  privileges: AssignedSocialHelpResponsePayload | null;
}

const initialState: PrivilegeState = {
  privileges: null,
};

export const privilegeSlice = createSlice({
  name: '@@eskso/privilege',
  initialState,
  reducers: {
    setPrivileges: (state, action: PayloadAction<AssignedSocialHelpResponsePayload>) => {
      return {
        ...state,
        privileges: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const privilege = privilegeSlice.reducer;
